"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterVariables = void 0;
const __1 = require("..");
exports.filterVariables = (cfjson, variableNames) => {
    const { dimensions, variables } = __1.normalizeNcoJson(cfjson);
    return {
        ...cfjson,
        variables: {
            ...dimensions.reduce((prev, { key, ...dimensionalVariable }) => {
                return { ...prev, [key]: dimensionalVariable };
            }, {}),
            ...Object.fromEntries(variables
                .filter(({ key }) => {
                var _a;
                if (key === 'time') {
                    return true;
                }
                const standard_name = (_a = cfjson.variables[key].attributes) === null || _a === void 0 ? void 0 : _a.standard_name;
                if (!standard_name)
                    return true;
                return variableNames.includes(standard_name);
            })
                .map(({ key, ...variable }) => {
                return [key, variable];
            })),
        },
    };
};
